import { useIntl } from '@tink/core/src/components/providers/LanguageProvider/useIntl';
import React, { useCallback } from 'react';
import { ErrorReason, ErrorStatus } from '@tink/core/src/tinkLinkErrorCodes';
import { Severity } from '@tink/core/src/components/atoms/Icons/AlertIcon';
import { useDispatch } from 'react-redux';
import { VerboseErrorScreen } from '../../../components/screens/VerboseErrorScreen/VerboseErrorScreen';
import { PageView } from '../../../models/analytics';
import { setApplicationError } from '../../../stores/app-state-store';
import { CommonError } from '../../../stores/app-state-errors';
import { messages } from './messages';

export const FRAUD_PREVENTION_CHECK_FAILED: CommonError = {
  errorStatus: ErrorStatus.USER_CANCELLED_WITH_ALTERNATE_FLOW,
  errorReason: ErrorReason.FAILED_FRAUD_PREVENTION_CHECK,
};

export const FraudPreventionErrorScreen = () => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const handleClose = useCallback(() => {
    dispatch(setApplicationError(FRAUD_PREVENTION_CHECK_FAILED));
  }, [dispatch]);

  return (
    <VerboseErrorScreen
      viewEvent={PageView.FRAUD_PREVENTION_SCREEN}
      severity={Severity.USER_ERROR}
      title={formatMessage(messages.title)}
      body={[{ text: formatMessage(messages.description) }]}
      primaryAction={handleClose}
      primaryButtonText={formatMessage(messages.close)}
    />
  );
};
